import type { MutableRefObject, ReactNode } from 'react'
import React, { createContext, createRef, useRef } from 'react'

type ParentRef = MutableRefObject<HTMLDivElement | null>

export const PopoverParentContext = createContext<ParentRef>(createRef())

type PopoverParentProps = {
  children: (ref: ParentRef) => ReactNode
  boundaryRef?: ParentRef
}

/**
 * This component allows to set the element that will be used as a parent for
 * all Popover components bellow it. This DOES not affect boundaries used for
 * calculations, will only be used for HTML parenting.
 */
export const PopoverParent = ({
  children,
  boundaryRef,
}: PopoverParentProps) => {
  const parentRef = useRef<HTMLDivElement | null>(null)
  const ref = boundaryRef || parentRef

  return (
    <PopoverParentContext.Provider value={ref}>
      {children(ref)}
    </PopoverParentContext.Provider>
  )
}
